import { z } from 'zod';

export const userFormSchema = z
  .object({
    name: z.string().min(1, 'Nome é obrigatório'),
    email: z.string().email('Email inválido'),
    password: z.string().optional().or(z.literal('')),
    confirmPassword: z.string().optional().or(z.literal('')),
    role: z.enum(['admin', 'store_admin'], {
      message: 'Selecione um nível de permissão',
    }),
    storeIds: z.array(z.string()).default([]),
    _isEditing: z.boolean(),
  })
  .superRefine((data, ctx) => {
    if (!data._isEditing) {
      if (!data.password || data.password.length < 6) {
        ctx.addIssue({
          code: 'custom',
          message: 'Senha deve ter no mínimo 6 caracteres',
          path: ['password'],
        });
      }
    } else if (data.password && data.password.length > 0 && data.password.length < 6) {
      ctx.addIssue({
        code: 'custom',
        message: 'Senha deve ter no mínimo 6 caracteres',
        path: ['password'],
      });
    }

    if (data.password && data.password.length > 0 && data.password !== data.confirmPassword) {
      ctx.addIssue({
        code: 'custom',
        message: 'As senhas não coincidem',
        path: ['confirmPassword'],
      });
    }

    if (!data._isEditing && !data.confirmPassword) {
      ctx.addIssue({
        code: 'custom',
        message: 'Confirmação de senha é obrigatória',
        path: ['confirmPassword'],
      });
    }

    if (data.role === 'store_admin' && data.storeIds.length === 0) {
      ctx.addIssue({
        code: 'custom',
        message: 'Selecione ao menos uma loja para o admin de loja',
        path: ['storeIds'],
      });
    }

    if (data.role === 'admin' && data.storeIds.length > 0) {
      ctx.addIssue({
        code: 'custom',
        message: 'Admin geral não deve ter lojas associadas',
        path: ['storeIds'],
      });
    }
  });

export type UserFormData = z.infer<typeof userFormSchema>;
